import { render, staticRenderFns } from "./TableTaxDetailsPrepayment.vue?vue&type=template&id=0eaf6baa&"
import script from "./TableTaxDetailsPrepayment.vue?vue&type=script&lang=ts&"
export * from "./TableTaxDetailsPrepayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eaf6baa')) {
      api.createRecord('0eaf6baa', component.options)
    } else {
      api.reload('0eaf6baa', component.options)
    }
    module.hot.accept("./TableTaxDetailsPrepayment.vue?vue&type=template&id=0eaf6baa&", function () {
      api.rerender('0eaf6baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/invoices-prepayment-debit-memo/TableTaxDetailsPrepayment.vue"
export default component.exports